export default "__VITE_ASSET__B6E7pLV5__"